import GoogleAuth from "./googleAuth.service";

const googleAuthModule = angular
  .module("app.services.googleAuth", [])
  .service("GoogleAuth", GoogleAuth);

export default googleAuthModule;



// WEBPACK FOOTER //
// ./src/services/googleAuth/googleAuth.module.js